export function getAlgodConfigFromEnvironment() {
  return {
    server: process.env.NEXT_PUBLIC_NODE_URL || '',
    port: process.env.NEXT_PUBLIC_NODE_PORT || '',
    token: process.env.NEXT_PUBLIC_NODE_TOKEN || ''
  }
}

export const algodConfig = getAlgodConfigFromEnvironment()
